import getConfig from 'next/config';
import { Box, Skeleton, Stack, useMediaQuery, Typography, Button } from '@mui/material';
// Disabling rule due to this issue https://stackoverflow.com/questions/69202975/module-not-found-cant-resolve-swiper-react
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from 'swiper/react';
import { useContext, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import SwiperCarousel from '../shared/SwiperCarousel';
import DeviceContext from './Device.context';
import getGeneralImage from '../../../util/getGeneralImage';

const { publicRuntimeConfig } = getConfig();

const DeviceBrandCarousel = ({ brands, filterBrand, loading, cmsData }) => {
  const { styles } = useContext(DeviceContext);
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectBrand, setSelectedBrand] = useState('');

  const handleBrandClick = e => {
    filterBrand(e.target.id);
    setSelectedBrand(e.target.id);
  };
  const spaceBetween = () => {
    if (brands.length === 1) return 0;
    if (xs) return 8;
    return 1;
  };
  useEffect(() => {
    setSelectedBrand('AllBrands');
  }, []);

  return loading ? (
    // Skeleton on load
    <Stack direction='row' justifyContent='center' spacing={2}>
      {Array(4)
        .fill()
        .map((_, i) => (
          <Skeleton
            key={i}
            variant='circular'
            sx={{ height: { xs: 65, sm: 100 }, width: { xs: 65, sm: 100 } }}
          />
        ))}
    </Stack>
  ) : (
    <SwiperCarousel
      settings={{
        className: 'brand-carousel',
        slidesPerView: 'auto',
        spaceBetween: spaceBetween(),
        centerInsufficientSlides: true,
      }}
      style={styles(theme).root}
    >
      <SwiperSlide key={0}>
        <Button
          id='AllBrands'
          // src={null}
          onClick={handleBrandClick}
          height='100%'
          sx={selectBrand === 'AllBrands' ? styles(theme).buttonSelected : styles(theme).button}
          aria-label='View all brands'
        >
          <Typography variant='inputLabel' id='AllBrands' sx={styles(theme).brandText}>
            All Brands
          </Typography>
        </Button>
      </SwiperSlide>
      {brands.map((brand, i) => (
        <SwiperSlide key={i + 1}>
          <Box
            id={brand.manufacturer}
            component='img'
            role='button'
            tabIndex={0}
            title={brand.manufacturer}
            src={
              brand.logo
                ? brand.logo
                : `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
                    getGeneralImage({
                      generalImageArray: cmsData?.attributes?.GeneralImage_Mobile,
                      key: 'brandImage',
                      view: 'MobileViewImage',
                    }).url
                  }`
            }
            onClick={handleBrandClick}
            onKeyDown={e => {
              // prevent Space from scrolling
              if (e.key === ' ') e.preventDefault();
            }}
            onKeyUp={e => {
              // activate on Enter/Space so NVDA reads the correct item
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleBrandClick(e);
              }
            }}
            sx={
              brand.manufacturer === selectBrand
                ? styles(theme).buttonSelected
                : styles(theme).button
            }
          />
        </SwiperSlide>
      ))}
    </SwiperCarousel>
  );
};

export default DeviceBrandCarousel;
